import React, { RefObject } from "react";

interface HeroProps {
  videoRef: RefObject<HTMLVideoElement>;
  title: string;
  metaDescription: string;
}

const Hero: React.FC<HeroProps> = ({ videoRef, title, metaDescription }) => {
  return (
    <div className="relative">
      <video
        ref={videoRef}
        autoPlay
        loop
        playsInline
        muted
        className="object-cover w-full max-w-[120rem] mx-auto rounded-lg h-[26rem] lg:h-[30rem] drop-shadow-lg"
        poster="/videos/street-lawyer-services-cannabis-festival-washington-dc-poster.webp"
      >
        <source
          src="/videos/street-lawyer-services-cannabis-festival-washington-dc.mp4"
          type="video/mp4"
        />
        {/* Fallback image if video fails */}
        <img
          src="/videos/street-lawyer-services-cannabis-festival-washington-dc-poster.jpg"
          alt="Street Lawyer Services Dispensary Washington DC"
          className="object-cover w-full h-full"
        />
      </video>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/20 rounded-lg flex items-center justify-center">
        <div className="text-center px-6 md:max-w-4xl">
          <h1 className="mt-4 mb-4 text-4xl md:text-5xl pt-[12vh] lg:text-6xl font-bold text-white drop-shadow-lg">
            {title}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-6 max-w-3xl mx-auto leading-relaxed">
            {metaDescription.substring(0, 100)}...
          </p>
          <a
            href="#content"
            className="inline-block text-white hover:text-cannabis-green-300 transition-colors"
          >
            <svg
              className="w-10 h-10 animate-bounce"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              ></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
